/** Scenario / tree slug for API: trimmed, uppercase, words separated by underscores. */
export const normalizeScenarioTree = value => {
  if (value == null || value === '') {
    return value;
  }
  const trimmed = String(value).trim();
  if (!trimmed) {
    return '';
  }
  return trimmed.replace(/\s+/g, '_').toUpperCase();
};

/** Human-readable scenario for UI (edit form, tables): lowercase, spaces instead of underscores. */
export const formatScenarioTreeForDisplay = value => {
  if (value == null || value === '') {
    return '';
  }
  return String(value)
    .replaceAll('_', ' ')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();
};
